export default "export default {\n\tserver: {\n\t\topen: 'index.html'\n\t}\n};\n"